<template>
  {{ formattedPrice }}
</template>

<script>

/**
 * Vue: price-formatter (price-formatter)
 * -----------------------------------------------------------------------------
 * Gift guide section.
 * - Static section.
 *
 */
export default {
  name: 'PriceFormatter',
  props: {
    price: {
      type: Number || String,
      required: true,
    },
  },
  computed: {
    formattedPrice() {
      return this.$formatMoney(this.price, window.cnvs.store.moneyFormat)
    },
  },
}
</script>
